import type { Tile6UpProps } from './types';
import { BuildContextProvider } from '../../providers';
import SixTileCarousel from './SixTileCarousel';

export default function Tile6UpShoppable({ header, tiles, variant }: Tile6UpProps) {
    return (
        <BuildContextProvider>
            <SixTileCarousel
                className="tile6up-shoppable"
                alignText="center"
                data-testid="shoppable-component-test-id"
                header={header}
                tiles={tiles}
                variant={variant}
                overrideDefaultClass
            />
        </BuildContextProvider>
    );
}
